/* unplugin-vue-components disabled */import script from "./SidebarButton.vue?vue&type=script&setup=true&lang=js"
export * from "./SidebarButton.vue?vue&type=script&setup=true&lang=js"

import "./SidebarButton.vue?vue&type=style&index=0&id=3a0c695a&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3a0c695a"]])

export default __exports__